"use client";

import { useEarthGlobe } from "../context/earth-globe-context";
import { EarthGlobe } from "./earth-globe-r3f";

/**
 * Componente persistente del globo terrestre.
 * Se monta una sola vez en el layout protegido y nunca se desmonta.
 * El canvas se mueve entre el contenedor oculto y el target del dashboard
 * mediante DOM reparenting, evitando la recarga de la escena 3D.
 */
export function PersistentEarthGlobe() {
  const {
    initialized,
    satellites,
    selectedSatelliteIndex,
    parkingRef,
    canvasWrapperRef,
    legendContent,
  } = useEarthGlobe();

  return (
    <div
      ref={parkingRef}
      style={{
        position: "absolute",
        width: 0,
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        pointerEvents: "none",
      }}
      aria-hidden
    >
      <div
        ref={canvasWrapperRef}
        style={{
          position: "absolute",
          inset: 0,
          overflow: "hidden",
          borderRadius: "inherit",
        }}
      >
        {initialized && (
          <EarthGlobe
            satellites={satellites}
            selectedSatelliteIndex={selectedSatelliteIndex}
            earthXOffset={0}
            legendContent={legendContent}
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
            }}
          />
        )}
      </div>
    </div>
  );
}
